import {useEffect, useState} from 'react';
import API from '../Services/API';
import State from './State';

const getAssets = async (assetIds) => {
    return new Promise((resolve, reject) => {
        const query = 'assetIds[]=' +assetIds.sort().join('&assetIds[]=');

        if (State.get(['assets', query])) {
            return resolve(State.get(['assets', query]));
        }

        API.get('/assets?' + query).then(as => {
            State.put(['assets', query], as);
            resolve(as);
        });
    });
}

const useAssets = (assetIds) => {
    const [assets, setAssets] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!assetIds) {
            setAssets([]);
            setIsLoading(false);
            return;
        }

        getAssets(assetIds).then(setAssets).finally(() => setIsLoading(false));
    }, [assetIds]);

    return {assets, isLoading};
}

export {
    getAssets,
    useAssets,
};
